import { render, staticRenderFns } from "./vcFooter.vue?vue&type=template&id=86ecfab2&scoped=true&"
import script from "./vcFooter.vue?vue&type=script&lang=js&"
export * from "./vcFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ecfab2",
  null
  
)

export default component.exports